import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const euApi = AiseaApiFactory.get("enterpriseUser");

export default {
  async addUser(_, payload) {
    let res = await euApi.add(payload);
    if(!res.status) {
      throw res;
    }
  },
};
